// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"f60024cc","101":"82e11da7","165":"7760c581","265":"1d1921a8","309":"cdc7068d","405":"2457a883","453":"bfae1bc5","664":"5d200ebe","724":"7fc5c311","744":"d26fdb52","904":"8f19e9f5","932":"50dfa915"}[chunkId] + ".chunk.js";
};